const { __ } = wp.i18n;
const { InspectorControls, InnerBlocks, TextAlignmentControl } = wp.blockEditor;
const { useState, useEffect, useRef } = wp.element;
const { useSelect } = wp.data;
const { PanelBody, __experimentalHeading, TextControl, __experimentalInputControl, __experimentalInputControlSuffixWrapper, __experimentalToggleGroupControl, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOptionIcon, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import { useBlockProps } from '@wordpress/block-editor';
import DimensionsControl from '../../controls/dimensions/dimensions.js';
import ShortUniqueId from 'short-unique-id';
import { heading } from '@wordpress/icons';
import { attributes } from '../attributes.js';
import { generateCSS, getCssCustomBlock, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage } from '../functions.js';
import CustomAttributeControl from '../../controls/custom-attribute/custom-attribute.js';
import ColorSelector from '../../controls/color-select/color-select.js';
import BorderControl from '../../controls/border/border.js';
import TypographyControl from '../../controls/typography/typography.js';
import BacgroundControl from '../../controls/background/background.js';
import DisplayControl from '../../controls/display/display.js';
import CssCustom from '../../controls/css-custom/css-custom.js';
import SizingControl from '../../controls/sizing/sizing.js';
import DynamicDropdown from '../../controls/dynamic/dropdown/dropdown.js'
import './heading.css';

wp.blocks.registerBlockType('softlite-io-integration/heading', {
    apiVersion: 3,
    title: __('Heading'),
    icon: heading,
    category: 'softlite-io-integration',
    attributes: addAttributeResponsive(attributes),
    edit: (props) => {
        const { attributes, setAttributes } = props;
        const [css, setCss] = useState('');
        const [openPanel, setOpenPanel] = useState({ setting: 'settings', style: 'layout' });
        const generateID = new ShortUniqueId({ length: 8, dictionary: 'alphanum_lower' });
        const [headingContent, setHeadingContent] = useState(attributes?.heading?.content ? attributes?.heading?.content.replace(/&lt;/g, "<") : '');
        const { id, custom_attributes } = attributes;
        const [attributeCustom, setAttributeCustom] = useState({});
        const openTab = attributes?.state?.openTab ?? 'setting';
        const openSettingSection = attributes?.state?.openSettingSection ?? 'settings';
        const openStyleSection = attributes?.state?.openStyleSection ?? 'layout';

        const currentDevice = useSelect((select) => {
            return select('core/edit-post').__experimentalGetPreviewDeviceType();
        }, []);
        const device = currentDevice.toLowerCase();
        const deviceString = device === 'desktop' ? '' : `:${device}`;

        useEffect(() => {
            if (!id) {
                setAttributes({ id: generateID.rnd() });
            }
            const newCss = generateCSS(attributes, `softlite-block-${attributes.id}`);
            let cssCustomString = getCssCustomBlock(attributes);
            setAttributes({ css: newCss });
            setCss(replaceBackgroundImage(cssCustomString + newCss, softliteData.site_url));
            setAttributeCustom(getCustomAttribute(custom_attributes));
        }, [attributes]);

        const handleToggle = (name, type) => {
            setAttributes({state: {...attributes?.state, [type]: name === attributes?.state?.[type] ? '' : name}});
        };

        const handleChangeHeading = (newHeading) => {
            setHeadingContent(newHeading);
            setAttributes({ heading: { ...attributes?.heading, content: newHeading } })
        }

        const handleSelectShortcode = (shortcode) => {
            const updatedContent = (headingContent ?? "") + shortcode;
            handleChangeHeading(updatedContent);
        };

        const TagName = attributes?.heading?.tag || 'h1';

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';

        const blockProps = useBlockProps({
            className: 'softlite-block-heading' + (headingContent === '' ? ' softlite-block-empty' : '') + advancedClassNames,
        });

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="softlite-tab-panel"
                        activeClass="active-tab"
                        onSelect={(newTab) => setAttributes({state: {...attributes?.state, openTab: newTab}})}
                        initialTabName={openTab}
                        tabs={[
                            {
                                name: 'setting',
                                title: 'Setting',
                                className: 'softlite-tab-setting',
                            },
                            {
                                name: 'style',
                                title: 'Style',
                                className: 'softlite-tab-style',
                            },
                        ]}
                    >
                        {(tab) => <div>
                            {openTab == 'setting' && (
                                <PanelBody title={__('Settings')} opened={openSettingSection === 'settings'} onToggle={() => handleToggle('settings', 'openSettingSection')}>
                                    <__experimentalInputControl
                                        label="Content"
                                        onChange={(newHeading) => handleChangeHeading(newHeading)}
                                        value={headingContent}
                                        suffix={
                                            <__experimentalInputControlSuffixWrapper variant="icon" style={{'padding-right': '0px'}}>
                                                <DynamicDropdown onSelect={handleSelectShortcode} />
                                            </__experimentalInputControlSuffixWrapper>}
                                    />
                                    <SelectControl
                                        label="HTML Tag"
                                        value={attributes?.heading?.tag}
                                        options={[
                                            { label: 'h1', value: 'h1' },
                                            { label: 'h2', value: 'h2' },
                                            { label: 'h3', value: 'h3' },
                                            { label: 'h4', value: 'h4' },
                                            { label: 'h5', value: 'h5' },
                                            { label: 'h6', value: 'h6' },
                                        ]}
                                        labelPosition="edge"
                                        className="softlite-heading-select"
                                        onChange={(newTag) => setAttributes({ heading: { ...attributes?.heading, tag: newTag } })}
                                    />
                                </PanelBody>
                            )}
                            {openTab == 'style' && (
                                <>
                                    <PanelBody title={__('Layout')} opened={openStyleSection === 'layout'} onToggle={() => handleToggle('layout', 'openStyleSection')} >
                                        <__experimentalHeading>SPACING</__experimentalHeading>
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="padding"
                                        />
                                        <__experimentalDivider />
                                        <label>Margin</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="margin"
                                        />
                                        <__experimentalDivider />
                                        <SizingControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Typography')} opened={openStyleSection === 'typography'} onToggle={() => handleToggle('typography', 'openStyleSection')}>
                                        <TypographyControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Background')} opened={openStyleSection === 'background'} onToggle={() => handleToggle('background', 'openStyleSection')}>
                                        <BacgroundControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Border')} opened={openStyleSection === 'border'} onToggle={() => handleToggle('border', 'openStyleSection')}>
                                        <BorderControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Attributes')} opened={openStyleSection === 'custom-attribute'} onToggle={() => handleToggle('custom-attribute', 'openStyleSection')}>
                                        <CustomAttributeControl
                                            items={custom_attributes}
                                            onChange={(newItems) => setAttributes({ custom_attributes: newItems })}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Custom CSS')} opened={openStyleSection === 'custom-css'} onToggle={() => handleToggle('custom-css', 'openStyleSection')}>
                                        <CssCustom
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                </>
                            )}
                        </div>}
                    </TabPanel>
                </InspectorControls>

                <TagName {...blockProps} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: headingContent }} />
                {css && (
                    <style type='text/css'>{css}</style>
                )}
            </>
        );
    },
    save: (props) => {
        const { attributes } = props;
        let headingContent = attributes?.heading?.content ? attributes?.heading?.content : '';
        headingContent = headingContent.replace(/&lt;/g, "<");
        const TagName = attributes?.heading?.tag || 'h1';
        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';
        const allClassNames = `softlite-block-heading${advancedClassNames}`;
        let attributeCustom = getCustomAttribute(attributes?.custom_attributes);

        return (
            <>
                <TagName className={allClassNames} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: headingContent }} />
            </>
        )
    },
});